import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const LocationEmptyState = {
  locations: [],
  selectedLocation: null,
  selectedLocationMultiple: [],
};

export const LocationKey = 'locations';

export const locationsSlice = createSlice({
  name: 'locations',
  initialState: getLocalStorage(LocalStorageTypes.LOCATIONS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.LOCATIONS))
    : LocationEmptyState,
  reducers: {
    setLocations: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.LOCATIONS, result);
      return { ...state, ...action.payload };
    },
    updateSelectedLocation: (state, action) => {
      const result = { ...state, selectedLocation: action.payload };
      persistLocalStorage(LocationKey, result);
      return result;
    },
    updateSelectedLocationMultiple: (state, action) => {
      const result = { ...state, selectedLocationMultiple: action.payload };
      persistLocalStorage(LocationKey, result);
      return result;
    },
    resetLocations: () => {
      clearLocalStorage('locations');
      return LocationEmptyState;
    },
  },
});

export const {
  setLocations,
  updateSelectedLocation,
  updateSelectedLocationMultiple,
  resetLocations,
} = locationsSlice.actions;
